import TemplateView from "./../../TemplateView";
import {AuditActionTypes} from "./constants";
import messageResource from "../../messageResource";
import {DateFormat} from "../../date_format";

export class AuditInfoRecord extends TemplateView {
    constructor(audit) {
        super();
        this.timestamp = audit.timestamp;
        this.subject = audit.subject;
        this.type = audit.type;
    }

    templateHtml() {
        return "<div class='auditInfoRecord ellipsis'><%-action%> <%-by%></div>";
    }

    templateModel() {
        return {
            action: this._actionTitle(),
            by: this._actionBy()
        };
    }

    _actionTitle() {
        const actionTime = Date.parseJSONTimeWithoutTimeZone(this.timestamp);
        const timeLabel = new DateFormat(window.SystemSettings.dateFormat).formatDate(actionTime);
        const message = (this.type === AuditActionTypes.CREATED) ? "audit.audit_history.create_info_record" : "audit.audit_history.update_info_record";
        return messageResource.getMessage(message, [timeLabel]);
    }

    _actionBy() {
        if (this.subject)
            return messageResource.getMessage('audit.audit_history.by', [JSON.parse(this.subject['data'])['name']]);
        return "";
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/auditHsitory/AuditInfoRecord.js